import { Component, OnInit } from '@angular/core';
import { LoginService } from "../service/login/login.service";
import { NzMessageService } from 'ng-zorro-antd';
import { NzModalService } from 'ng-zorro-antd';


import axios from 'axios'

@Component({
  selector: 'app-policy-detail',
  templateUrl: './policy-detail.component.html',
  styleUrls: ['./policy-detail.component.css']
})
export class PolicyDetailComponent implements OnInit {


  title: any;
  time: any;
  content: any;
  img: any;
  imgList: any[];
  MethodService: any;
  render;
  downReport: boolean;
  id: string;



  constructor(
    private service: LoginService,
    private message: NzMessageService,
    private modalService: NzModalService
  ) { }

  ngOnInit() {
    this.title = localStorage.getItem("detailtit");
    this.id = localStorage.getItem("detailid");
    this.time = localStorage.getItem("detailtime");
    this.content = localStorage.getItem("detailcontent");
    this.img = localStorage.getItem("detailImg");

    var lists = this.img.split(",");
    this.imgList = lists;
    console.log(this.id);
    console.log(this.img);
    console.log(this.title);
    console.log(this.time);
    console.log(this.content);
    console.log(lists);
    console.log(this.imgList);
  }




  // 下载为PDF
  down() {
    console.log("点击下载按钮")
    var downid = localStorage.getItem('detailid')
    console.log(downid)
    this.service.getDown(downid).subscribe((res: any) => {
      console.log(res)
      console.log(res.result);
      window.open(res.result, '_blank')
      // axios({
      //   method: "get",
      //   url: res.result,//路径拼接时间戳
      //   responseType: 'blob',//接受使用分片方式
      // }).then((res) => {
      //   let url = window.URL.createObjectURL(res.data)
      //   let a = document.createElement('a');//创建a标签
      //   a.href = url;//标签路径
      //   a.download = '文件下载';//下载文件名称
      //   a.click();//模拟点击
      // }).catch((err) => {
      //   console.log("err", err)
      // });

    })

  }



  // 字体大小
  plus() {
    console.log("点击变大")
    var para = document.getElementById("writing");

    var s = para.style.fontSize;//利用+将i和px连接起来
    console.log(s)

    // console.log(para);
    // var s = para.style.fontSize;
    if (para.style.fontSize = "24px") {
      this.modalService.warning({
        nzTitle: '已是最大字体！',
        nzContent: '字体大小不可再增大！'
      });
    }
    else {
      var size = parseInt(s) + 1;
      para.style.fontSize = size + "px";
    }
  }

  minus() {
    console.log("点击变小")
    var para2 = document.getElementById("writing");
    var s = para2.style.fontSize;
    if (parseInt(s) == 14) {
      this.modalService.warning({
        nzTitle: '已是最小字体！',
        nzContent: '字体大小不可再减小！'
      });
    }
    else {
      var size = parseInt(s) - 1;
      para2.style.fontSize = size + "px";
    }
  }


}
